/* 
  考试中心
*/ 

import Ajax from "./ajax";
import { jsToFormData } from "@/utils/func";
//考试中心 我的考试
export const getMyExams = data => Ajax.get(`/fs-new-exam-apply`, data);  //成教考试
export const getMyExamsOwn = data => Ajax.get(`/v1-own-student-new-exam-list`, data);  //自考考试
export const getExamsNotice = data => Ajax.post(`/fs-exam-apply-ask`, jsToFormData(data));
export const resetSign = data => Ajax.post(`/fs-exam-apply-reset`, jsToFormData(data));

//我的考试-参与考试
export const examInfo = data => Ajax.get(`/fs-new-exam-apply-info`, data); //查询试卷
export const startExam = data => Ajax.get(`/fs-new-exam-join`, data); //进入考试 进入时请求一次  进入后先请求一次

//我的考试 详情 
export const getUserInfo = () => Ajax.get(`/fs-user-index-info`, null);

//我的考试答题
export const postAnswer = data => Ajax.post(`/fs-new-exam-question-answer`, data); //上传答题
export const topicSubmit = data => Ajax.post(`/fs-new-exam-question-submit`, data); //提交
export const getUpExamLog = (data) => Ajax.post(`/fs-new-exam-log`, jsToFormData(data));
export const examUpScreenshot = data => Ajax.post(`/fs-new-exam-up-screenshot`, jsToFormData(data)); //考试截图

 
// 人脸识别
export const faceServe = {
    // personVerify: data => Ajax.unsafePost("/fs-new-exam-face-card", jsToFormData(data)),
    newPersonVerify: data => Ajax.unsafePost("/fs-new-exam-face-card", jsToFormData(data)),
    // userSearch: data => Ajax.unsafePost("/fs-user-face-face", jsToFormData(data)),// 人脸搜faceServe索
    // recognizeCard: (data, headers) => Ajax.unsafePost("/fs-user-card-phone", jsToFormData(data), headers),// 身份证识别
    // postPhoto: (data, headers) => Ajax.unsafePost("/fs-post-photo", jsToFormData(data), headers),
    // realChecks: data => Ajax.post("/fs-user-post-review-photo", jsToFormData(data)),// 真人审核
    // uploadFile: (data, headers) => Ajax.unsafePost("/fs-user-card-phone", jsToFormData(data), { token: headers }),// 身份证上传图片
    getStudent: data => Ajax.get(`/fs-get-photo`, data,false),// 获取上传图片地址
  };
  

//阅卷
export const getCheckExamsAll = data => Ajax.get(`/fs-new-exam-my-marking`, data); // 列表获取
export const getExamsAll = data => Ajax.get(`/fs-new-exam-exam`, data); // 考试筛选获取

//考试 按卷批改
export const getExamStudentAll = data => Ajax.get(`/fs-new-exam-student-list`, data); // 考试筛选获取
export const getAllAnswer = data => Ajax.get(`/fs-new-exam-student-info`, data); //按卷子页 获取试题列表
export const autoSave = data => Ajax.post(`/fs-new-exam-student-correct`, jsToFormData(data)); //提交分数

//按题阅卷 
export const getQuestionsExamAll = data => Ajax.get(`/fs-new-exam-question`, data); // 按题阅题列表获取
export const getQuestionsInfo = data => Ajax.get(`/fs-new-exam-question-record`, data); //按卷子页 获取试题列表
export const getQuestionsCorrect = data => Ajax.post(`/fs-new-exam-question-correct`, jsToFormData(data)); //提交分数

// 成绩记录 - 成教
export const adultStudentNewScoreRecord = data => Ajax.get(`/v1-adult-student-new-score-record`, data); // 获取考生成绩记录

// 补考报名
export const adultStudentSupplyExamGet = data => Ajax.get(`/v1-adult-student-supply-exam-get`, data); // 获取补考考试
export const adultStudentSupplyCourseGet = data => Ajax.get(`/v1-adult-student-supply-course-get`, data); // 获取补考课程
export const adultStudentSupplySign = data => Ajax.post(`/v1-adult-student-supply-sign`, jsToFormData(data)); // 补考报名

// 考签查看 - 自考
export const ownStudentNewExamInfo = data => Ajax.get(`/v1-own-student-new-exam-info`, data); // 学生考签查看

// 免考申请
export const studentGeCourseAll = data => Ajax.get(`/v1-adult-student-get-course-all`, data); // 获取学生要学的全部课程
export const studentExemptApplyPost = data => Ajax.post(`/v1-adult-student-exempt-apply-post`, jsToFormData(data)); // 免考申请提交
export const studentExemptApplyGet = data => Ajax.get(`/v1-adult-student-exempt-apply-get`, data); // 获取免考申请记录
export const studentExemptApplyCourse = data => Ajax.get(`/v1-adult-student-exempt-apply-course`, data); // 获取申请的课程

